module.exports = __webpack_public_path__ + "static/media/common-misconceptions-about-payment.0e34cf5e.md";